import { commitMutation, graphql } from 'react-relay';

function getMutation() {
  return graphql`
    mutation EmailSignupMutation($input: EmailSignupInput!) {
      emailSignup(input: $input) {
        success
      }
    }
  `;
}

function getInputs(formFields) {
  return {
    form: {
      formFields,
      email: formFields.email.fieldInput,
      formName: 'emailSignup',
    },
  };
}

function commit({ environment, formFields, onCompleted, onError }) {
  const input = getInputs(formFields);
  const mutation = getMutation();

  return commitMutation(environment, {
    mutation,
    onCompleted,
    onError,
    variables: { input },
  });
}

export default { commit };
